import { Actions } from './actions';
import {
  CLEAN_SCAN,
  CLEAN_SCAN_IMG,
  GET_SCAN_PHOTO_ERROR,
  GET_SCAN_PHOTO_REQUEST,
  GET_SCAN_PHOTO_SUCCESS,
  SET_TYPE_SCAN,
} from './constants';

export const initialState = {
  scan: null as null | any,
  typeDoc: '' as string,
  index: null as number | null,
  loading: false as boolean,
  error: null as null | Error,
  isSuccess: false as boolean,
};

export type ScanerState = typeof initialState;

export const scanerReducer = (state: ScanerState = initialState, action: Actions): ScanerState => {
  switch (action.type) {
    case SET_TYPE_SCAN: {
      return {
        ...state,
        loading: false,
        typeDoc: action.typeDoc,
        index: action.index,
        error: null,
      };
    }
    case GET_SCAN_PHOTO_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_SCAN_PHOTO_SUCCESS: {
      return {
        ...state,
        scan: action.payload,
        error: null,
      };
    }
    case GET_SCAN_PHOTO_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        scan: null,
      };
    }
    case CLEAN_SCAN_IMG: {
      return {
        ...state,
        loading: false,
        error: null,
        scan: null,
      };
    }
    case CLEAN_SCAN: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
